import { render, staticRenderFns } from "./OsobaRazdobljeDetails.vue?vue&type=template&id=242a743f&scoped=true&"
import script from "./OsobaRazdobljeDetails.vue?vue&type=script&lang=js&"
export * from "./OsobaRazdobljeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a743f",
  null
  
)

export default component.exports